// extracted by mini-css-extract-plugin
export var boxIcons = "product-tour-w-description-module--boxIcons--cc648";
export var description = "product-tour-w-description-module--description--a0ca9";
export var desktopContainer = "product-tour-w-description-module--desktopContainer--d2d02";
export var epigraphBtn = "product-tour-w-description-module--epigraphBtn--6ef4a";
export var eyebrow = "product-tour-w-description-module--eyebrow--df96e";
export var getpricingcta = "product-tour-w-description-module--getpricingcta--a7746";
export var headline = "product-tour-w-description-module--headline--c8aa2";
export var helperText = "product-tour-w-description-module--helperText--c6bd6";
export var links = "product-tour-w-description-module--links--49a97";
export var mobileProductTourContainer = "product-tour-w-description-module--mobileProductTourContainer--d1b3b";
export var picture = "product-tour-w-description-module--picture--bd8bd";
export var productTour = "product-tour-w-description-module--productTour--04558";
export var productTourContainer = "product-tour-w-description-module--productTourContainer--7a433";
export var productTourMobileButton = "product-tour-w-description-module--productTourMobileButton--09f16";
export var tabletLinks = "product-tour-w-description-module--tabletLinks--e8699";
export var viewSauna = "product-tour-w-description-module--viewSauna--4c2ce";
export var wrapper = "product-tour-w-description-module--wrapper--501e4";